import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { resetPassword, signIn } from '../controls';
import { showSnackbar } from '../Snackbar';


export default function SignIn(props) {
  const [showPassword, setShowPassword] = React.useState(false);

  // const [forceResetpassword, setForceResetpassword] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    if(data.get('password') === "12345678"){
      showSnackbar("Please reset the default password first or change your password", "error");
      return;
    }

    signIn(data.get('email'), data.get('password'))

    // console.log({
    //   email: data.get('email'),
    //   password: data.get('password'),
    // });
  };

  const handleClickPasswordReset = () => {
    const data = new FormData(document.getElementById('myForm'));
    resetPassword(data.get('email'));
  };

  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography component="h1" variant="h6" sx={{ fontWeight: 650 }}>
        Sign in
      </Typography>
      <Typography sx={{ mt: 0.4, mb: 2, color: "text.secondary", fontSize: 14 }}>
        Use your agent credentials to continue.
      </Typography>

      <Box component="form" id='myForm' onSubmit={handleSubmit} noValidate>
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          autoFocus
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type={showPassword ? "text" : "password"}
          id="password"
          autoComplete="current-password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <FormControlLabel
          sx={{ mt: 0.5 }}
          control={<Checkbox value="remember" color="primary" />}
          label="Remember me"
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 1.3, mb: 1.2, py: 1.1, fontWeight: 600 }}
        >
          Sign In
        </Button>

        <Grid container sx={{ mt: 0.5 }}>
          <Grid item xs>
            <Link component="button" onClick={handleClickPasswordReset} variant="body2" sx={{ fontWeight: 600 }}>
              Forgot/Reset password?
            </Link>
          </Grid>
          <Grid item>
            <Link component="button" onClick={()=>props.setView("signup")} variant="body2" sx={{ fontWeight: 600 }}>
              {"Create account"}
            </Link>
          </Grid>
        </Grid>
      </Box>

      <Typography
        component="span"
        sx={{ mt: 1.5, fontSize: '0.7rem', color: 'text.disabled' }}
      >
        v1.50
      </Typography>
    </Box>
  );
}
